<template>
  <div>
    <h3 style="text-align: center;margin-bottom: 10px">选择拣货区域</h3>
    <el-row :gutter="12">
      <template v-for="item of partition_list">

        <el-col :span="12" :key="item.id" v-if="user_info&&user_info.depot === 1 && item.warehouse ===1">
          <el-card shadow="always" style="text-align: center" @click.native="selectPartition(item.id,item.name)">
            {{ item.name }} 区
          </el-card>
        </el-col>
        <el-col :span="12" :key="item.id" v-else-if="user_info&&user_info.depot === 0 && item.warehouse ===0">
          <el-card shadow="always" style="text-align: center" @click.native="selectPartition(item.id,item.name)">
            {{ item.name }} 区
          </el-card>
        </el-col>
      </template>
      <el-col :span="12" >
        <el-card shadow="always" style="text-align: center" @click.native="gotoCancelList">
          作废列表
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "PickIndex",
  data() {
    return {
      partition_list: [],
      user_info : JSON.parse(localStorage.getItem('user_info'))
    }
  },
  methods: {
    gotoCancelList(){
      var that = this;

      that.$router.push({
        path: '/cancel',
        query: {
          depot: that.user_info.depot,
        }
       })
    },
    //选择分区
    selectPartition(p,n) {

      this.$router.push({
        path: '/pickList',
        query: {
          p: p,
          n:n
        }
      })
    },

    //获取分区列表
    getPartitionList() {
      this.http.fetchGet(this.api.partition_list).then((res) => {
        // console.log(res)
        let data = res.data;
        if (data.code === 200) {
          this.partition_list = data.data
        }

      }).catch((err) => {
        console.log(err)
      })
    }
  },
  mounted() {
    this.getPartitionList()
  },
}
</script>

<style scoped lang="stylus">

.el-col
  margin-bottom 10px

</style>
